import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './ForgotPasswordModal.css'; 

const ResetPassword = () => {
  // Grab the secret codes directly from the URL (the /:uidb64/:token part)
  const { uidb64, token } = useParams();
  const navigate = useNavigate();

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // 1. Check if passwords match before bothering the server
    if (newPassword !== confirmPassword) {
      setStatus('error');
      setMessage('Passwords do not match!');
      return;
    }

    setStatus('loading');

    try {
      // 2. Send the new password to your Django Confirm API
      await axios.post(`/api/users/password-reset/confirm/${uidb64}/${token}/`, { new_password: newPassword });

      setStatus('success');
      setMessage('Password reset successfully! You can now log in.');
    } catch (error) {
      setStatus('error');
      setMessage(error.response?.data?.error || error.response?.data?.detail || 'Invalid or expired link. Please request a new one.');
    }
  };

  return (
    <div className="reset-page-container">
      <div className="reset-card">
        <h2>Create New Password</h2>
        
        {status === 'success' ? (
          <div className="success-message">
            <span className="success-icon">🎉</span>
            <p>{message}</p>
            <button className="submit-btn mt-3" onClick={() => navigate('/login')}>Go to Login</button>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <label>New Password</label>
              <input 
                type="password" 
                required 
                value={newPassword} 
                onChange={(e) => setNewPassword(e.target.value)} 
                minLength="8"
                placeholder="Enter new password"
              />
            </div>
            <div className="input-group">
              <label>Confirm Password</label>
              <input 
                type="password" 
                required 
                value={confirmPassword} 
                onChange={(e) => setConfirmPassword(e.target.value)} 
                minLength="8"
                placeholder="Confirm new password"
              />
            </div>
            
            {status === 'error' && <p className="error-text">{message}</p>}
            
            <button type="submit" className="submit-btn" disabled={status === 'loading'}>
              {status === 'loading' ? 'Saving...' : 'Reset Password'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;